/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@material-ui/core";
import React, { useContext, useState } from "react";
import CircularProgressWithLabel from "../../../components/CircularProgressWithLabel";
import SingleSelect from "../../../components/SelectField/SingleSelect";
import { getDocCount } from "../../../services/apiservices/counters";
import { COLLECTIONS } from "../../../services/config";
import styles from "../dashboard.module.scss";
import moment from "moment/moment";
import AuthContext from "../../../hooks/authContext";
import { Notifications as NotificationsIcon } from "@mui/icons-material";

function Notifications(props) {
  const auth = useContext(AuthContext);
  const [notificationDataemail, setNotificationDataEmail] = useState([]);
  const [notificationDataapp, setNotificationDataApp] = useState([]);
  const [notificationDataboth, setNotificationDataBoth] = useState([]);

  const [totalemail, setTotalEmail] = useState([]);
  const [totalsms, setTotalSms] = useState([]);
  const [totalboth, setTotalBoth] = useState([]);

  const [progress, setProgress] = useState();
  const [frequency, setFrequency] = useState("All");
  const frequencyList = [
    { label: "All", value: "All" },
    { label: "Today", value: "Today" },
  ];
  const companyId =
    auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;
  const datefilter = (data, datet) => {
    const filterdata = data.filter(
      (item) => moment(item.createdOn).format(moment.HTML5_FMT.DATE) === datet
    );
    return filterdata;
  };

  const onChangeInput = (e) => {
    setFrequency(e.target.value);
    if (e.target.value === "All") {
      setTotalEmail(notificationDataemail.length);
      setTotalSms(notificationDataapp.length);
      setTotalBoth(notificationDataboth.length);
    }
    if (e.target.value === "Today") {
      let filterdate = moment().format(moment.HTML5_FMT.DATE);
      let emaildata = datefilter(notificationDataemail, filterdate);
      let smsdata = datefilter(notificationDataapp, filterdate);
      let bothdata = datefilter(notificationDataboth, filterdate);

      setTotalEmail(emaildata.length);
      setTotalSms(smsdata.length);
      setTotalBoth(bothdata.length);
    }
  };
  const updateProgress = (newval) => {
    setProgress(newval);
  };
  React.useEffect(() => {
    getDocCount(
      COLLECTIONS.NOTIFICATIONS,
      (res) => {
        const data = res?.filter((item) => item.companyId === companyId);
        updateProgress(data?.length);

        const emailtype = data?.filter((item) => {
          const types = Array.isArray(item.Type) ? item.Type : [item.Type];
          return types.includes("Email");
        });

        const apptype = data?.filter((item) => {
          const types = Array.isArray(item.Type) ? item.Type : [item.Type];
          return types.includes("Push");
        });

        const Bothtype = data?.filter((item) => {
          const types = Array.isArray(item.Type) ? item.Type : [item.Type];
          return (
            types.includes("Both") ||
            (types.includes("Email") &&
              types.includes("Push") &&
              types.includes("PushNotification"))
          );
        });

        setNotificationDataEmail(emailtype);
        setNotificationDataApp(apptype);
        setNotificationDataBoth(Bothtype);

        setTotalEmail(emailtype.length);
        setTotalSms(apptype.length);
        setTotalBoth(Bothtype.length);
        updateProgress(data.length);
      },
      (resError) => {
        console.log("reserror", resError);
      }
    );
  }, []);

  return (
    <>
      <Grid item xs={12} sm={7} lg={12} className="mb-20">
        <div className="d-flex flex-center mb-10">
          <NotificationsIcon
            style={{
              color: "rgba(34, 197, 94, 1)",
            }}
          />
          <p className="p-0 m-0 ml-10 fonthe dark:text-white">Notifications</p>
        </div>
        <div style={{ marginBottom:"10px",width:"100%", border:"1px solid #E2E8F0"}}></div>
        <SingleSelect
          value={frequency}
          className={`field newonr`}
          name={"frequency"}
          onChange={(e) => onChangeInput(e)}
          options={frequencyList}
        />
      </Grid>
      <ul>
        <li className={styles.listItem2}>
          <Grid container spacing={1}>
            <Grid item xs={6} sm={9} className="text-gray-500 dark:text-gray-100">
              Email
            </Grid>
            <Grid item xs={6} sm={3} className="text-right dark:text-[#94A3B8]">
              <strong>{totalemail ? totalemail : 0}</strong>
            </Grid>
          </Grid>
        </li>

        <li className={styles.listItem2}>
          <Grid container spacing={1}>
            <Grid item xs={6} sm={9} className="text-gray-500 dark:text-gray-100">
              Sms
            </Grid>
            <Grid item xs={6} sm={3} className="text-right dark:text-[#94A3B8]">
              <strong>{totalsms ? totalsms : 0}</strong>
            </Grid>
          </Grid>
        </li>
        <li className={styles.listItem2}>
          <Grid container spacing={1}>
            <Grid item xs={6} sm={9} className="text-gray-500 dark:text-gray-100">
              Both
            </Grid>
            <Grid item xs={6} sm={3} className="text-right dark:text-[#94A3B8]">
              <strong>{totalboth ? totalboth : 0}</strong>
            </Grid>
          </Grid>
        </li>
      </ul>

      <Grid item xs={12} sm={5} lg={12} className="mt-10">
        <CircularProgressWithLabel value={progress} wrapclass="#21b792" title={"Progress"}/>
      </Grid>
    </>
  );
}

export default Notifications;
